import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config'; // Make sure this resolves correctly
import { useQuery,useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import ReactModal from 'react-modal';
import { useLocation, useNavigate, Link } from 'react-router-dom';



function FamilyTreeSister() {
    const location = useLocation();
  const memberId = location.state?.memberId;

  const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
 

  const navigate = useNavigate();

    const { menu, toggleMobileMenu } = useAppLayout();

    const chartContainerRef = useRef(null);
    const chartInstanceRef = useRef(null);
  
    const queryClient = useQueryClient();
  
    const getToken = () => localStorage.getItem('token');
  
  
    //automatically save member_id
  
    const hasPostedRef = useRef(false);
  
  useEffect(() => {
    if (memberId && !hasPostedRef.current) {
      hasPostedRef.current = true;
  
      axios.post(`${API_URL}/family-tree-save-sister-member-id`, { memberId })
        .then((response) => {
          // toast.success('Member ID saved successfully!');
        })
        .catch((error) => {
          console.error('Error saving ID:', error);
          toast.error('Failed to save member ID');
        });
    }
  }, [memberId]);
  
  
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState({
      id: '',
      name: '',
      alt_name: '',
      img: '',
      gender: '',
      married: '',
      single: '',
      single_mother: '',
      spouse: '',
      unknown: '',
    });
  
  
  const openModalWithData = (data) => {
    setSelectedMember({
      id: data.id || '',
      name: data.name || '',
      alt_name: data.alt_name || '',
      img: data.img || '',
      gender: data.gender || '',
      married: data.married || '',
      single: data.single || '',
      single_mother: data.single_mother || '',
      spouse: data.spouse || '',
      unknown: data.unknown || '',
    });
    setModalIsOpen(true);
  };
  
  
   // Query to fetch family tree data
  
    const { data: familyTreeData, isLoading: isLoadingFamilyTree, isError: isErrorFamilyTree } = useQuery({
      queryKey: ['familyTree', memberId], // track query by memberId too
      queryFn: () =>
        axios
          .get(`${API_URL}/family-tree-sister`, {
            params: { memberId }, // pass memberId as query param
            headers: {
              Authorization: `Bearer ${getToken()}`,
            },
          })
          .then((res) => res.data),
      enabled: !!memberId, // only run when memberId is available
      staleTime: 0,
      cacheTime: Infinity,
    });
  
  
  
     // Load OrgChart script when data is available
     useEffect(() => {
      if (!familyTreeData) return; // Wait for data to be available
  
      loadScript(`${process.env.PUBLIC_URL}/orgchart/orgchart.js`)
        .then(() => {
          initializeOrgChart(familyTreeData);
          //console.log("family TreeData:", familyTreeData);
        })
        .catch((error) => {
          console.error('Failed to load OrgChart script:', error);
        });
  
      return () => {
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }
      };
    }, [familyTreeData]); // Runs only when familyTreeData is updated
  
  
  
  
    const [addFamilyModalIsOpen, setAddFamilyModalIsOpen] = useState(false);
  
    const openAddFamilyModal = () => {
      setAddFamilyModalIsOpen(true);
    };
    
    const closeAddFamilyModal = () => {
      setAddFamilyModalIsOpen(false);
    };
  
    
    //check if father/mother is added
    const [hasFather, setHasFather] = useState(false);
  const [hasMother, setHasMother] = useState(false);
  
  useEffect(() => {
    if (selectedMember?.id) {
      axios.post(`${API_URL}/family-tree-sister-check-father-mother-api`, {
        selected_id: selectedMember.id
      }, { withCredentials: true })
        .then(res => {
          setHasFather(res.data.hasFather);
          setHasMother(res.data.hasMother);
        })
        .catch(err => {
          console.error("Error fetching parent info:", err);
        });
    }
  }, [selectedMember]);
  
  
  
  const getRelationshipOptions = () => {
    const { gender, married, single, single_mother } = selectedMember || {};
  
    let baseOptions = [];
  
  
    if (gender === 'Male') {
      baseOptions = ['Father', 'Mother', 'Spouse', 'Brother', 'Sister', 'Son', 'Daughter'];
    } else if (gender === 'Female') {
      baseOptions = ['Father', 'Mother', 'Brother', 'Sister'];
    }
  
    // Logic to conditionally remove "Father" or "Mother"
    if (hasFather && hasMother) {
      baseOptions = baseOptions.filter(rel => rel !== 'Father' && rel !== 'Mother');
    } else if (hasFather && !hasMother) {
      baseOptions = baseOptions.filter(rel => rel !== 'Father');
    } else if (!hasFather && !hasMother) {
      baseOptions = baseOptions.filter(rel => rel !== 'Mother'); // show only Father
    }
  
    // Step 2: Remove Step-Mother if not both parents are present
    if (!(hasFather && hasMother)) {
      baseOptions = baseOptions.filter(rel => rel !== 'Step-Mother');
    }
    
  
    return baseOptions;
  };
  
  
  
    const [selectedRelationship, setSelectedRelationship] = useState('');
    const [isDeceased, setIsDeceased] = useState(false);
    const [selectedPrefix, setSelectedPrefix] = useState("");
  
  
    const getPrefixOptions = () => {
  
      const maleRelations = ['Father', 'Son', 'Brother'];
      const femaleRelations = ['Mother', 'Daughter', 'Sister', 'Spouse'];
    
      const neutral = ['Dr', 'Prof', 'Rev'];
    
      if (maleRelations.includes(selectedRelationship)) {
        return ['Mr', ...neutral];
      }
    
      if (femaleRelations.includes(selectedRelationship)) {
        return ['Mrs', ...neutral];
      }
    
      // Default
      return ['Mr', 'Mrs', ...neutral];
    };
  
  
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
  
    const initializeOrgChart = (data) => {
      if (!window.OrgChart) return;
      const isMobile = window.innerWidth <= 768;
      const OrgChart = window.OrgChart;
  
      OrgChart.templates.family_template = Object.assign({}, OrgChart.templates.ana);
      OrgChart.templates.family_template.size = [86, 86];
      OrgChart.templates.family_template.plus = '';
      OrgChart.templates.family_template.minus = '';
      OrgChart.templates.family_template.rippleRadius = 40;
      OrgChart.templates.family_template.name = '<text style="font-size: 12px;" fill="#000000" x="43" y="100" text-anchor="middle">{val}</text>';
      OrgChart.templates.family_template.title = '<text style="font-size: 12px;" fill="#aeaeae" x="43" y="115" text-anchor="middle">{val}</text>';
    const baseImg = '<clipPath id="{randId}"><circle cx="43" cy="43" r="40.5"></circle></clipPath><image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="2" y="2" width="82" height="82"></image>';
  OrgChart.templates.family_template.node = '<circle stroke-width="1" fill="#FF1493" stroke="#FF1493" cx="43" cy="43" r="41.5"></circle>';
  OrgChart.templates.family_template.img = baseImg + `
  <circle fill="#ffffff" stroke="#cccccc" stroke-width="1" cx="77" cy="72" r="10"></circle>
  <text x="77" y="77" text-anchor="middle" font-size="16" fill="#FF1493" font-weight="bold">+</text>
  `;
  OrgChart.templates.family_template_blue = Object.assign({}, OrgChart.templates.family_template);
    OrgChart.templates.family_template_blue.node = '<circle stroke-width="1" fill="#2C533D" stroke="#2C533D" cx="43" cy="43" r="41.5"></circle>';
  OrgChart.templates.family_template_blue.img = baseImg + `
  <circle fill="#ffffff" stroke="#cccccc" stroke-width="1" cx="77" cy="72" r="10"></circle>
  <text x="77" y="77" text-anchor="middle" font-size="16" fill="#2C533D" font-weight="bold">+</text>
  `;
      const chart = new OrgChart(chartContainerRef.current, {
        template: 'family_template',
        enableSearch: true,
        levelSeparation: isMobile ? 60 : 100,
        siblingSeparation: isMobile ? 60 : 100,
        scaleInitial: isMobile ? OrgChart.match.boundary : 1,
        scaleMin: 0.5,
        scaleMax: 3,
        
        nodeBinding: {
          name: 'name',
          title: 'title',
          img: 'img',
          
        },
        tags: {
          blue: { template: 'family_template_blue' },
          partner: { template: 'family_template' },
        },
  
        nodeMouseClick: OrgChart.action.none, // override default popup
  
      });
  
      chart.on('render-link', (sender, args) => {
        if (args.cnode.ppid !== undefined) {
          args.html += '<use xlink:href="#baby" x="' + args.p.xa + '" y="' + args.p.ya + '"/>';
        }
      });
  
      chart.on('redraw', function () {
        const chartElement = document.querySelector('#tree svg');
        if (chartElement) {
          chartElement.style.touchAction = 'pan-x pan-y';
        }
      });
  
      /*chart.on('click', (sender, args) => {
        if (args && args.node) {
          const nodeData = sender.get(args.node.id); // Gets the full node data from the chart
          openModalWithData(nodeData);
        }
      });*/
  
      chart.on('click', (sender, args) => {
        if (args && args.node) {
          const nodeData = sender.get(args.node.id);
          setTimeout(() => {
            openModalWithData(nodeData);
          }, 150); // Slight delay fixes the flash
        }
      });
  
      chart.load(data);
      chartInstanceRef.current = chart;
    };
  
  
  //spouse list
  const [spouseList, setSpouseList] = useState([]);
  useEffect(() => {
    if (addFamilyModalIsOpen && selectedMember) {
      fetchSpouses();
    }
  }, [addFamilyModalIsOpen, selectedMember]);
  
  const fetchSpouses = async () => {
    try {
      const response = await axios.post(`${API_URL}/family-tree-sister-get-spouse-api`, {
        withCredentials: true,
        selected_id: selectedMember.id,
      });
      setSpouseList(response.data);
    } catch (error) {
      console.error('Error fetching spouses:', error);
    }
  };
  //
  
  
  //mother list
  const [motherList, setMotherList] = useState([]);
  useEffect(() => {
    if (addFamilyModalIsOpen && selectedMember) {
      fetchMothers();
    }
  }, [addFamilyModalIsOpen, selectedMember]);
  
  const fetchMothers = async () => {
    try {
      const response = await axios.post(`${API_URL}/family-tree-sister-get-mother-api`, {
        withCredentials: true,
        selected_id: selectedMember.id,
      });
      setMotherList(response.data);
    } catch (error) {
      console.error('Error fetching mothers:', error);
    }
  };
  //
  
  
  //image preview
  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
    
   //submit member details
   const [formData, setFormData] = useState({
    name: '',
    last_name: '',
    surname: '',
    gender: '',
    date_of_birth: '',
    date_of_death: '',
    relationship: '',
    prefix: '',
    deceased: false,
    selected_id: '',
    mother_id: ''
    
  });
  
  
  useEffect(() => {
    if (selectedMember) {
      setFormData((prev) => ({
        ...prev,
        selected_id: selectedMember.id, 
      }));
    }
  }, [selectedMember]);
  
  
  
  
  // Helper to reset the form
  const resetForm = () => {
    setFormData({
      name: '',
      last_name: '',
      surname: '',
      gender: '',
      date_of_birth: '',
      date_of_death: '',
      relationship: '',
      prefix: '',
      deceased: false,
      selected_id: selectedMember?.id || '', // optionally preserve selected_id
      mother_id: ''
    });
    setImageFile(null);
    setSelectedRelationship('');
    setSelectedPrefix('');
    setIsDeceased(false);
  };
  
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmitMemberDetails = async () => {
    // Validation: Required relationship
    if (!formData.relationship) {
      toast.error("Relationship is required", { position: "top-right", autoClose: 3000 });
      return;
    }
  
    const needsMotherId = ['Brother', 'Sister', 'Son', 'Daughter'].includes(formData.relationship);
    const isSingleMother = selectedMember?.single_mother === 1 || selectedMember?.single_mother === '1';
  
    if (needsMotherId && !formData.mother_id && !isSingleMother) {
      toast.error("Mother is required for this relationship", { position: "top-right", autoClose: 3000 });
      return;
    }
  
    if (!formData.name) {
      toast.error("First name is required", { position: "top-right", autoClose: 3000 });
      return;
    }
  
  
    //Start submission only if all validation passes
    setIsSubmitting(true);
    const submissionData = new FormData();
  
    // Mother ID
    if (needsMotherId) {
      submissionData.append('mother_id', isSingleMother ? '0' : formData.mother_id);
    }
  
    // Append regular fields
    for (const key in formData) {
      if (
        key !== 'deceased' &&
        key !== 'mother_id'
      ) {
        if (formData[key] !== undefined && formData[key] !== null) {
          submissionData.append(key, formData[key]);
        }
      }
    }
  
    // Append special fields
    submissionData.append('deceased', formData.deceased ? '1' : '0');
  
    if (imageFile) {
      submissionData.append('image', imageFile);
    }
  
    if (selectedMember?.id) {
      submissionData.append('selected_member_id', selectedMember.id);
    }
  
    if (memberId) {
      submissionData.append('member_id', memberId);
    }
  
    try {
      const response = await axios.post(
        `${API_URL}/family-tree-sister-add-member-api`,
        submissionData,
        { withCredentials: true }
      );
  
      if (response.data.success) {
        queryClient.invalidateQueries(['familyTree']);
        closeAddFamilyModal();
        setModalIsOpen(false);
        toast.success("Family member added successfully", { position: "top-right", autoClose: 3000 });
        
        resetForm();
      } else {
        toast.error(response.data.message || "Failed to add member", { position: "top-right", autoClose: 3000 });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      const backendMsg = error.response?.data?.message || error.message;
      toast.error(backendMsg || "An error occurred while adding member.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false); // Re-enable submit button
    }
  };
  
  
  //family info
  const {
    data: familyInfo = [],          // default to empty array
    isLoadingInfo,
    isErrorInfo,
  } = useQuery({
    queryKey: ['familyInfo', memberId],
    queryFn: () =>
      axios
        .get(`${API_URL}/family-info-sister`, {
          params: { memberId },     // <-- only the query‑param
          withCredentials: true,    // keep if you rely on cookies; else drop
        })
        .then(res => res.data),
    enabled: !!memberId,            // guard against undefined id
  });
  
  //end family info
  
  //save family info
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [viewInfoModalOpen, setViewInfoModalOpen] = useState(false);
  
  const [formDataInfo, setFormDataInfo] = useState({
    tribe: '',
    subtribe: '',
    subgroup: '',
    clan: '',
    totem: '',
    family: '',
  });
  
  //
  const handleOpenFamilyInfoModal = () => {
    if (familyInfo.length > 0) {
      setFormDataInfo(familyInfo[0]); // Load existing values into form
    } else {
      setFormDataInfo({ tribe: '', subtribe: '', subgroup: '', clan: '', totem: '', family: '' });
    }
    setInfoModalOpen(true);
  };
  //
  
  const isUpdating = familyInfo.length > 0;
  
  const handleSaveFamilyInfo = () => {
    const { tribe } = formDataInfo;
    if (!tribe.trim()) {
      toast.error("Tribe is required");
      return;
    }
  
    axios.post(`${API_URL}/save-family-info-sister`, {
      ...formDataInfo,
      user_id: memberId,
    }, { withCredentials: true })
      .then(() => {
        toast.success(isUpdating ? "Family info updated successfully" : "Family info saved successfully");
        setInfoModalOpen(false);
        setFormDataInfo({ tribe: '', subtribe: '', subgroup: '', clan: '', totem: '', family: '' });
        queryClient.invalidateQueries(['familyInfo', memberId]);
      })
      .catch(err => {
        console.error("Error saving family info:", err);
        toast.error("Error saving family info");
      });
  };
  
  
   const [modalAccent, setModalAccent] = useState('#184A2C'); 
    const deriveAccentFromNode = (nodeData) => {
      if (nodeData?.tags?.includes('blue')) return '#184A2C';    
      if (nodeData?.tags?.includes('partner')) return '#FF1493';  
      return '#FF1493'; 
    };
  
    
  
 

  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />
        <ToastContainer />

        <div className="page-wrapper">
        
        <div className="content container-fluid">
        
        
        {isLoadingFamilyTree ? (
            <div className="loadingspinnerDiv">
              <div className="loadingspinner"></div>
            </div>
          ) : isErrorFamilyTree ? (
            <p>Error loading family tree data.</p>
          ) : (
            <>
          
        
        <div className='row'>
            {/* ── Top nav bar ── */}
        <div className="col-md-12" style={{backgroundColor: '#fdf5e6'}}>
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 16,
        }}>
        <Link
        to="/family-tree"
        style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        border: '1px solid rgba(44,83,61,0.25)',
        color: '#184A2C',
        textDecoration: 'none',
        flexShrink: 0,
        transition: 'background 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.background = '#e3f2e9'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
        <i className="fa fa-arrow-left" style={{ fontSize: 14 }} />
        </Link>
        
        <button
        className="btn btn-sm"
        onClick={handleOpenFamilyInfoModal}
        title="Add / edit spouse family information"
        style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '5px 12px',
        border: '1px solid rgba(44,83,61,0.3)',
        borderRadius: 999,
        background: 'transparent',
        color: '#184A2C',
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
        }}
        >
        <i className="fas fa-pen fa-xs" />
        Edit Info
        </button>
        
        {familyInfo.length > 0 && (
        <button
        className="btn btn-sm"
        onClick={() => setViewInfoModalOpen(true)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '5px 12px',
          border: '1px solid rgba(44,83,61,0.3)',
          borderRadius: 999,
          background: '#e3f2e9',
          color: '#184A2C',
          fontSize: 12,
          fontWeight: 500,
          cursor: 'pointer',
        }}
        >
        <i className="fas fa-eye fa-xs" />
        View Info
        </button>
        )}
        </div>
        
        {/* ── Edit / Add Modal ── */}
        <ReactModal
        isOpen={infoModalOpen}
        onRequestClose={() => setInfoModalOpen(false)}
        className="Modal"
        overlayClassName="Overlay"
        ariaHideApp={false}
        >
        <div style={{ padding: '28px 28px 20px', maxWidth: 480, margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 24 }}>
        <div style={{
          width: 44, height: 44, borderRadius: '50%',
          background: '#e3f2e9',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <i className="fas fa-heart" style={{ color: '#184A2C', fontSize: 18 }} />
        </div>
        <div style={{ flex: 1 }}>
          <h4 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#184A2C' }}>
            {familyInfo.length > 0
              ? `${familyInfo[0]?.family || familyInfo[0]?.tribe || 'Sister Family'} Heritage`
              : 'Family Information'}
          </h4>
          <p style={{ margin: '3px 0 0', fontSize: 13, color: '#5a7a68' }}>
            {familyInfo.length > 0 ? "Update your spouse's family lineage" : 'Add family lineage details'}
          </p>
        </div>
        <button
          type="button"
          onClick={() => setInfoModalOpen(false)}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#888', fontSize: 18, padding: 4, lineHeight: 1,
          }}
        >
          <i className="fas fa-times" />
        </button>
        </div>
        
        {/* Fields */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px', marginBottom: 16 }}>
        {[
          { key: 'tribe',    icon: 'fa-exclamation-triangle', label: 'Tribe',       required: true,  placeholder: 'e.g. Kikuyu' },
          { key: 'subtribe', icon: 'fa-tree',                 label: 'Sub-tribe',   required: false, placeholder: 'e.g. Mathira' },
          { key: 'subgroup', icon: 'fa-users',                label: 'Sub-group',   required: false, placeholder: 'Enter sub-group' },
          { key: 'clan',     icon: 'fa-shield-alt',           label: 'Clan',        required: false, placeholder: 'Enter clan' },
          { key: 'totem',    icon: 'fa-paw',                  label: 'Totem',       required: false, placeholder: 'Enter totem' },
          { key: 'family',   icon: 'fa-home',                 label: 'Family Name', required: true,  placeholder: 'Enter family name' },
        ].map(({ key, icon, label, required, placeholder }) => (
          <div key={key}>
            <label style={{
              display: 'flex', alignItems: 'center', gap: 5,
              fontSize: 11, fontWeight: 600, color: '#5a7a68',
              textTransform: 'uppercase', letterSpacing: '0.05em',
              marginBottom: 5,
            }}>
              <i className={`fas ${icon}`} style={{ fontSize: 10 }} />
              {label}{required && <span style={{ color: '#d9534f' }}>*</span>}
            </label>
            <input
              type="text"
              value={formDataInfo[key] || ''}
              onChange={(e) => setFormDataInfo(p => ({ ...p, [key]: e.target.value }))}
              placeholder={placeholder}
              style={{
                width: '100%', boxSizing: 'border-box',
                padding: '8px 10px',
                border: '1px solid rgba(44,83,61,0.25)',
                borderRadius: 8,
                fontSize: 13,
                color: '#184A2C',
                background: '#f9fdf9',
                outline: 'none',
              }}
              onFocus={e => e.target.style.borderColor = '#2c533d'}
              onBlur={e => e.target.style.borderColor = 'rgba(44,83,61,0.25)'}
            />
          </div>
        ))}
        </div>
        
        <p style={{ fontSize: 11, color: '#8aab96', marginBottom: 20 }}>
        <i className="fas fa-info-circle" style={{ marginRight: 4 }} />
        Fields marked with * are required
        </p>
        
        {/* Footer */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={() => setInfoModalOpen(false)}
          style={{
            padding: '8px 20px', borderRadius: 999,
            border: '1px solid rgba(44,83,61,0.3)',
            background: 'transparent', color: '#184A2C',
            fontSize: 13, fontWeight: 500, cursor: 'pointer',
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSaveFamilyInfo}
          disabled={!formDataInfo.tribe?.trim()}
          style={{
            padding: '8px 20px', borderRadius: 999,
            border: 'none',
            background: !formDataInfo.tribe?.trim()
              ? '#ccc'
              : 'linear-gradient(135deg,#2c533d,#184A2C)',
            color: '#fff',
            fontSize: 13, fontWeight: 600, cursor: !formDataInfo.tribe?.trim() ? 'not-allowed' : 'pointer',
            transition: 'opacity 0.15s',
          }}
        >
          {familyInfo.length > 0 ? 'Update Info' : 'Save Info'}
        </button>
        </div>
        </div>
        </ReactModal>
        
        {/* ── View Info Modal ── */}
        <ReactModal
        isOpen={viewInfoModalOpen}
        onRequestClose={() => setViewInfoModalOpen(false)}
        className="Modal"
        overlayClassName="Overlay"
        >
        <div style={{ padding: '24px 24px 16px' }}>
        
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div style={{
          width: 40, height: 40, borderRadius: '50%',
          background: '#e3f2e9',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <i className="fas fa-leaf" style={{ color: '#184A2C', fontSize: 16 }} />
        </div>
        <div style={{ flex: 1 }}>
          <h5 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#184A2C' }}>
          Sister Family Info
          </h5>
        </div>
        <button
          type="button"
          onClick={() => setViewInfoModalOpen(false)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: 18, padding: 4 }}
        >
          <i className="fas fa-times" />
        </button>
        </div>
        
        {/* Body */}
        {isLoadingInfo && <p style={{ color: '#888', fontSize: 13 }}>Loading…</p>}
        {isErrorInfo && <p style={{ color: '#d9534f', fontSize: 13 }}>Couldn't load data.</p>}
        
        {familyInfo.length > 0 ? familyInfo.map(({ id, tribe, subtribe, subgroup, clan, totem, family }) => (
        <div key={id} style={{
          background: '#f9fdf9',
          border: '1px solid rgba(44,83,61,0.15)',
          borderRadius: 12,
          padding: '14px 16px',
        }}>
          {[
            { label: 'Tribe',      value: tribe },
            { label: 'Sub-tribe',  value: subtribe },
            { label: 'Sub-group',  value: subgroup },
            { label: 'Clan',       value: clan },
            { label: 'Totem',      value: totem },
            { label: 'Family',     value: family },
          ].map(({ label, value }) => (
            <div key={label} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '7px 0',
              borderBottom: '1px solid rgba(44,83,61,0.08)',
            }}>
              <span style={{ fontSize: 12, color: '#5a7a68', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {label}
              </span>
              <span style={{ fontSize: 14, color: '#184A2C', fontWeight: 500 }}>
                {value || '—'}
              </span>
            </div>
          ))}
        </div>
        )) : (!isLoadingInfo && !isErrorInfo &&
        <p style={{ fontSize: 13, color: '#888', textAlign: 'center' }}>No family information found.</p>
        )}
        </div>
        </ReactModal>
         
            
             
        
        <div id="tree" ref={chartContainerRef} style={{ width: '100%', height: '600px' }}></div>
        
        
        
        <ReactModal  isOpen={modalIsOpen} 
          onRequestClose={() => setModalIsOpen(false)} 
          className="modern-modal profile-modal" 
          overlayClassName="modern-overlay"
          ariaHideApp={false}
        >
          <div className="modal-container">
        
            <button 
              type="button" 
              className="modal-close-btn" 
              onClick={() => setModalIsOpen(false)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
        
           
            <div className="profile-image-section">
              <div
                className="large-profile-image-wrapper"
                style={{ background: `linear-gradient(135deg, ${modalAccent} 0%, ${modalAccent} 100%)` }}
              >
                {selectedMember.img ? (
                  <img
                    src={selectedMember.img}
                    alt={selectedMember.name}
                    className="large-profile-image"
                  />
                ) : (
                  <div className="large-profile-image-placeholder">
                    <svg width="120" height="120" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                )}
        
               
                <div className="image-overlay-info">
                  <h2 className="overlay-name">{selectedMember.name}</h2>
                </div>
              </div>
            </div>
        
           
            <div className="compact-action-buttons">
              {(selectedMember.unknown === '' && selectedMember.spouse === '') && (
                <button
                  type="button"
                  className="btn btn-compact btn-add"
                  onClick={openAddFamilyModal}
                  style={{ background: `linear-gradient(135deg, ${modalAccent} 0%, ${modalAccent} 100%)` }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Add Family
                </button>
              )}
        
              <button
                type="button"
                className="btn btn-compact btn-edit"
                onClick={() =>
                  navigate('/edit-personal-info-spouse', {
                    state: { editMemberId: selectedMember.id, memberId: memberId },
                  })
                }
                style={{ color: modalAccent, borderColor: modalAccent }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Edit
              </button>
        
              <button
                type="button"
                className="btn btn-compact btn-profile"
                onClick={() => navigate('/profile', { state: { memberId: selectedMember.id } })}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                </svg>
                Profile
              </button>
            </div>
          </div>
        </ReactModal>
        
        
        
        
        
        
        <ReactModal 
        isOpen={addFamilyModalIsOpen}
        onRequestClose={closeAddFamilyModal}
        className="Modal2 modern-modalx add-family-modal"
        overlayClassName="modern-overlay"
        ariaHideApp={false} >
        
        
        <div className="modal-containerx">
        
        
        <div className="text-center my-3 position-relative">
        
        
        <button
        type="button"
        className="btn-close position-absolute end-0 me-3"
        aria-label="Close"
        onClick={closeAddFamilyModal}
        />
        
        
        {/* Title */}
        <h5 className="fw-bold mb-1">Add Family Member</h5>
        
        {/* Subtitle */}
        <p className="text-muted mb-0">
        Adding to <span className="fw-semibold text-success">{selectedMember?.name || " "}</span>'s family tree
        </p>
        </div>
        
        <div className="modal-body-modern px-3 pt-2 pb-3" >
        
        <div className="row">
        <div className="col-md-12">
        
        <div className="image-upload-section mb-2">
        <div
        className="image-upload-wrapper"
        onClick={() => document.getElementById('uploadImageInput').click()}
        >
        <div className="image-preview">
        <img
          src={previewImage || 'img/avatar_male.png'}
          alt="Preview"
          className="preview-img"
        />
        <div className="upload-overlay" style={{ background: modalAccent }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="13" r="4" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </div>
        </div>
        <input
        id="uploadImageInput"
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            if (file.size > 5 * 1024 * 1024) {
              toast.error('Image size should be less than 5MB');
              return;
            }
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setPreviewImage(reader.result);
            reader.readAsDataURL(file);
          }
        }}
        />
        </div>
        </div>
        
        </div>
        </div>
        
        
        <div className='row'>
        <div className='col-6 col-md-6'>
        
        <label className="form-label-modern small mb-1">Select Relationship</label>
        <select
        className="form-input-modern form-control form-control-sm"
        value={formData.relationship}
        onChange={(e) => setFormData({ ...formData, relationship: e.target.value })}
        id="relationship"
        >
        <option value="">Choose relationship</option>
        {getRelationshipOptions().map((relation) => (
          <option key={relation} value={relation}>{relation}</option>
        ))}
        </select>
        
        </div>
        
        <div className='col-6 col-md-6'>
        
        
        {(formData.relationship === 'Brother' || formData.relationship === 'Sister') && (
        <>
        <label className='form-label-modern small'>Select Mother</label>
        <select
        className="form-input-modern form-control form-control-sm"
        value={formData.mother_id || ''}
        onChange={(e) => setFormData({ ...formData, mother_id: e.target.value })}
        >
        <option value="">Select Mother</option>
        {motherList.map((mother) => (
        <option key={mother.id} value={mother.id}>{mother.name}</option>
        ))}
        </select>
        </>
        )}
        
        {(formData.relationship === 'Son' || formData.relationship === 'Daughter'  && selectedMember.gender === 'Male') && (
        <>
        <label className='form-label-modern small'>Select Mother</label>
        <select
        className="form-input-modern form-control form-control-sm"
        value={formData.mother_id || ''}
        onChange={(e) => setFormData({ ...formData, mother_id: e.target.value })}
        >
        <option value="">Select Mother</option>
        {spouseList.map((spouse) => (
        <option key={spouse.id} value={spouse.id}>{spouse.name}</option>
        ))}
        </select>
        </>
        )}
        
        
        </div>
        </div>
        
        <div className='row'>
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>Prefix</label>
        <select
          className="form-input-modern form-control form-control-sm"
          value={formData.prefix}
          onChange={(e) => setFormData({ ...formData, prefix: e.target.value })}
        >
          <option value="">Select Prefix</option>
          {getPrefixOptions().map((prefix) => (
            <option key={prefix} value={prefix}>{prefix}</option>
          ))}
        </select>
        </div>
        
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>First Name *</label>
        <input
          type="text"
          name="name"
          className="form-input-modern form-control form-control-sm"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
        />
        </div>
        </div>
        
        <div className='row'>
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>Last Name</label>
        <input
          type="text"
          name="last_name"
          className="form-input-modern form-control form-control-sm"
          value={formData.last_name}
          onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
        />
        </div>
        
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>Surname</label>
        <input
          type="text"
          name="surname"
          className="form-input-modern form-control form-control-sm"
          value={formData.surname}
          onChange={(e) => setFormData({ ...formData, surname: e.target.value })}
        />
        </div>
        </div>
        
        <div className='row'>
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>Status</label>
        <label className="checkbox-wrapper">
        <input
          type="checkbox"
          name="deceased"
          className="checkbox-input"
          checked={formData.deceased}
          onChange={() => {
            setFormData((prev) => ({
              ...prev,
              deceased: !prev.deceased
            }));
          }}
        /> <span className="checkbox-label">Deceased</span>
        </label>
        </div>
        
        <div className='col-6 col-md-6'>
        <label className='form-label-modern small'>Date of Birth</label>
        <input
          type="date"
          name="date_of_birth"
          className="form-input-modern form-control form-control-sm"
          value={formData.date_of_birth}
          onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
        />
        
        {formData.deceased && (
          <>
            <label className='form-label-modern small'>Date of Death</label>
            <input
              type="date"
              name="date_of_death"
              className="form-input-modern form-control form-control-sm"
              value={formData.date_of_death}
              onChange={(e) => setFormData({ ...formData, date_of_death: e.target.value })}
            />
          </>
        )}
        </div>
        </div>
        
        </div>
        
        </div>
        
        <div className="modal-footer-modern py-2 px-3 d-flex justify-content-between">
        
        
        <button 
                type="button"
                onClick={closeAddFamilyModal}
                className="btn btn-cancel-modern btn-sm"
              >
                Cancel
              </button>
        
        {/*<button onClick={handleSubmitMemberDetails} className="btn btn-primary"
        disabled={isSubmitting}>
        {isSubmitting ? "Saving..." : "Save Member Details"}
        </button>*/}
        
        
        <button onClick={handleSubmitMemberDetails} className="btn btn-primary-modern btn-sm"
        disabled={isSubmitting}>
        
        {isSubmitting ? (
        <>
        <svg className="loading-spinner" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="3" fill="currentColor">
        <animate attributeName="r" values="3;5;3" dur="1s" repeatCount="indefinite"/>
        </circle>
        </svg>
        Saving...
        </>
        ) : (
        <>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="17,21 17,13 7,13 7,21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="7,3 7,8 15,8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Save Member
        </>
        )}
        
        </button>
        
        
        
        
        </div>
        </ReactModal>
        
        
        </div>
        </div>
        
        </>
        )}
        </div>

      </div>
      


      
      <style jsx>{`
      
      :root{
        --brand: #75B437;
        --brand-600: #5fa12f;
        --brand-700: #4d8e29;
        --brand-dark: #184A2C;
        --ink: #000000;
        --bg: #EBF4ED;
        --bg-soft: #f4faf6;
      }

     
      .theme-light, .scrollPageContainer { background: var(--bg); }

  
      .modern-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 20px;
        opacity: 0;
        animation: fadeIn 0.2s ease-out forwards;
        box-sizing: border-box;
        overflow-y: auto;
        min-height: 100vh;
      }
      @keyframes fadeIn { to { opacity: 1; } }
 .modern-modal { 
        background: transparent; 
        border: 0; 
        border-radius: 0; 
        box-shadow: none; 
        outline: none; 
        position: relative; 
        width: auto;
        max-width: none; 
        max-height: none; 
        overflow: visible; 
        margin: auto;
      }

      .modal-container{
        background: linear-gradient(145deg, #ffffff 0%, var(--bg-soft) 100%);
        border-radius: 24px;
        box-shadow: 0 25px 50px -12px rgba(0,0,0,.25), 0 0 0 1px rgba(255,255,255,.8);
        position: relative; 
        overflow: hidden;
        transform: scale(.95) translateY(20px);
        animation: modalSlideIn .3s ease-out forwards;
        backdrop-filter: blur(16px);
        max-height: calc(100vh - 40px);
        overflow-y: auto;
        margin: auto;
      }
      @keyframes modalSlideIn { to { transform: scale(1) translateY(0); } }

      .profile-modal .modal-container { width: 400px; max-width: 90vw; height: 600px; max-height: 85vh; display: flex; flex-direction: column; }
      .profile-image-section { flex: 1; position: relative; overflow: hidden; border-radius: 24px 24px 0 0; }
      .large-profile-image-wrapper{ width:100%; height:100%; position:relative; background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%); }
      .large-profile-image{ width:100%; height:100%; object-fit:cover; display:block; }
      .large-profile-image-placeholder{ width:100%; height:100%; display:flex; align-items:center; justify-content:center; color: rgba(255,255,255,.9); background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%); }
      .image-overlay-info{ position:absolute; left:0; right:0; bottom:0; background: linear-gradient(transparent, rgba(0,0,0,.75)); padding:40px 20px 20px; text-align:center; }
      .overlay-name{ font-size:28px; font-weight:700; margin:0; color:#fff; text-shadow:0 2px 8px rgba(0,0,0,.5); }





      .add-family-modal .form-input-modern {
  height: 36px !important;      
  padding: 0.25rem 0.5rem !important;
  font-size: 0.85rem !important; 
}
.add-family-modal .form-label-modern {
  margin-bottom: 0.25rem !important; 
  font-size: 0.8rem;
}


      .compact-action-buttons{
        padding:16px 20px; display:flex; gap:8px;
        background: rgba(248, 250, 252, .95);
        backdrop-filter: blur(10px);
        border-radius: 0 0 24px 24px;
        border-top:1px solid rgba(226,232,240,.8);
      }
      .btn-compact{ flex:1; display:flex; align-items:center; justify-content:center; gap:6px; padding:10px 8px; border-radius:10px; font-weight:600; font-size:12px; border:none; cursor:pointer; transition:.2s; outline:none; min-height:44px; }

      .btn-add{
        background: linear-gradient(135deg, var(--brand-dark) 0%, #0f3320 100%);
        color:#fff; box-shadow: 0 2px 8px rgba(24,74,44,.35);
      }
      .btn-add:hover{ transform: translateY(-1px); box-shadow: 0 4px 12px rgba(24,74,44,.45); }

      .btn-edit{
        background: transparent; color: var(--brand-dark);
        border: 2px solid var(--brand);
      }
      .btn-edit:hover{ background: var(--brand); color:#fff; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(117,180,55,.35); }

      .btn-profile{
        background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
        color:#fff; box-shadow: 0 2px 8px rgba(117,180,55,.35);
      }
      .btn-profile:hover{ transform: translateY(-1px); box-shadow: 0 4px 12px rgba(24,74,44,.45); }

   
      .modal-close-btn{
        position:absolute; top:16px; right:16px; width:36px; height:36px;
        background: rgba(255,255,255,.95); border:0; border-radius:50%;
        display:flex; align-items:center; justify-content:center; cursor:pointer;
        color:#475569; transition:.2s; z-index:10; backdrop-filter: blur(10px);
      }
      .modal-close-btn:hover{ background:#fff; color:#ef4444; transform: scale(1.1); }

  
      .add-fa3mily-modal .modal-container {
  width: 420px;       
  max-width: 92vw;   
  max-height: 72vh;    
}

      .modal-header-modern{ padding:24px 30px; border-bottom:1px solid #e2e8f0; display:flex; align-items:center; justify-content:space-between; background: linear-gradient(135deg, #f5faf7 0%, #e6f0ea 100%); }
      .modal-title-modern{ font-size:20px; font-weight:600; color:#1e293b; margin:0; }
      .highlight-name{ color: var(--brand-dark); font-weight:700; }
      .modal-body-modern{ padding:30px; overflow-y:auto; flex:1; }

      
      .image-upload-section{ display:flex; justify-content:center; margin-bottom:32px; }
      .image-upload-wrapper{ cursor:pointer; transition: transform .2s; }
      .image-upload-wrapper:hover{ transform: scale(1.05); }
      .image-preview{ position:relative; width:110px; height:110px; }
      .preview-img{ width:100%; height:100%; object-fit:cover; border-radius:50%; border:4px solid #e2e8f0; transition: border-color .3s; }
      .image-upload-wrapper:hover .preview-img{ border-color: var(--brand); }
      .upload-overlay{
        position:absolute; bottom:8px; right:8px; width:32px; height:32px;
        background: var(--brand-dark); border-radius:50%;
        display:flex; align-items:center; justify-content:center; color:#fff;
        box-shadow: 0 2px 8px rgba(24,74,44,.35); transition: transform .2s;
      }
      .image-upload-wrapper:hover .upload-overlay{ transform: scale(1.1); }


      
      .form-group{ display:flex; flex-direction:column; }
      .form-group.full-width{ grid-column: 1 / -1; }
      .form-label-modern{ font-size:14px; font-weight:600; color:#374151; margin-bottom:8px; display:flex; align-items:center; gap:4px; }
      .form-input-modern{
        padding:12px 16px; border:2px solid #e2e8f0; border-radius:12px;
        font-size:14px; color:#1e293b; background:#fff; transition:.2s; outline:none;
      }
      .form-input-modern:focus{ border-color: var(--brand); box-shadow: 0 0 0 3px rgba(117,180,55,.2); }
      .form-input-modern::placeholder{ color:#9ca3af; }

      .checkbox-group{ display:flex; flex-wrap:wrap; gap:16px; margin-top:8px; }
      .checkbox-wrapper{ display:flex; align-items:center; cursor:pointer; user-select:none; }
      .checkbox-input{ width:18px; height:18px; margin:0 8px 0 0; cursor:pointer; accent-color: var(--brand-dark); }
      .checkbox-label{ font-size:14px; color:#374151; font-weight:500; }

      .modal-footer-modern{ padding:24px 30px; border-top:1px solid #e2e8f0; display:flex; gap:12px; justify-content:flex-end; background:#f8fafc; }
  .btn{ display:inline-flex; align-items:center; gap:8px; padding:12px 20px; border-radius:12px; font-weight:600; font-size:14px; border:none; cursor:pointer; transition:.2s; outline:none; position:relative; overflow:hidden; }
      .btn:disabled{ opacity:.6; cursor:not-allowed; }
      .btn-primary-modern{
        background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
        color:#fff; box-shadow: 0 4px 12px rgba(117,180,55,.35);
      }
      .btn-primary-modern:hover:not(:disabled){ transform: translateY(-2px); box-shadow: 0 8px 20px rgba(24,74,44,.45); }
      .btn-cancel-modern{ background:#f1f5f9; color:#64748b; border:2px solid #e2e8f0; }
      .btn-cancel-modern:hover{ background:#e2e8f0; border-color:#cbd5e1; }

      .loading-spinner{ animation: spin 1s linear infinite; }
      @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }


      @media (max-width: 640px){
        .form-grid{ grid-template-columns:1fr; }
        .modal-container{ margin:10px; width: calc(100vw - 20px); }
        .profile-modal .modal-container{ height:500px; }
        .compact-action-buttons{ padding:12px 16px; flex-direction:column; gap:8px; }
        .btn-compact{ width:100%; font-size:13px; padding:12px; }
        .modal-header-modern, .modal-body-modern, .modal-footer-modern{ padding:20px; }
        .overlay-name{ font-size:24px; }
        .checkbox-group{ flex-direction:column; gap:12px; }
        
        .modern-overlay {
          padding: 10px;
          align-items: flex-start;
          padding-top: 20px;
        }
        
        .modal-container { 
          margin: 0;
          width: 100%;
          max-height: calc(100vh - 40px);
        }
      }

      @media (max-width: 480px){
        .compact-action-buttons{ padding:10px 12px; }
        .btn-compact{ font-size:11px; padding:10px 8px; gap:4px; }
        .overlay-name{ font-size:20px; }
        .profile-modal .modal-container{ height:450px; }
      }

    
      :root { --footerbar-height: 64px; }
      .tree-wrapper{ position:relative; width:100%; height:600px; }

.add-family-modal .checkbox-group{
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 24px;
  flex-wrap: nowrap;
  white-space: nowrap;
}
.add-family-modal .checkbox-wrapper{
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.add-family-modal .checkbox-input{
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--brand-dark);
}



    `}</style>






    </div>
    
  );
}

export default FamilyTreeSister;
